import {
  SITE_AUTHENTICATION_PATHS,
  SITE_AUTHENTICATION_ROUTES,
} from "src/consts/Routes/SiteAuthentication";
import { lazy, Suspense, useContext } from "react";
import FooterLinks from "../../Footer/FooterLinks";
import { ThemeValues } from "../../ThemeUsage/theme";
import { ThemeContext } from "../../ThemeUsage/ThemeUsage";
import { Route, Routes, useLocation } from "react-router-dom";
import { Container, Grid, Stack, useTheme } from "@mui/material";
import SiteAuthenticationProgressBar from "../../ProgressBar/MicroFrontend/SiteAuthentication";

const Start = lazy(() => import("src/pages/SiteAuthentication/Start"));
const Success = lazy(() => import("src/pages/SiteAuthentication/Success"));
const Failed = lazy(() => import("src/pages/SiteAuthentication/Failed"));
const AuthenticationCallback = lazy(
  () => import("src/pages/SiteAuthentication/AuthenticationCallback"),
);

const SiteAuthentication = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const themeName = useContext(ThemeContext);
  const isUserSelectEnabled = themeName !== ThemeValues.lichtblick;

  return (
    <Stack
      sx={{
        minHeight: "100vh",
        background: theme.palette.background.default,
        userSelect: isUserSelectEnabled ? undefined : "none",
      }}
    >
      <Container
        sx={{
          p: 4,
          flexGrow: 1,
          marginTop: { xs: 0, sm: 12 },
        }}
      >
        <Grid container>
          <Grid item xs={12} sm={4}>
            {SITE_AUTHENTICATION_ROUTES.includes(pathname) && (
              <SiteAuthenticationProgressBar />
            )}
          </Grid>

          <Grid item xs={12} sm={8} sx={{ paddingLeft: { sm: 5, md: 20 } }}>
            <Routes>
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <Start />
                  </Suspense>
                }
                path={SITE_AUTHENTICATION_PATHS.START}
              />
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <Success />
                  </Suspense>
                }
                path={SITE_AUTHENTICATION_PATHS.SUCCESS}
              />
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <Failed />
                  </Suspense>
                }
                path={SITE_AUTHENTICATION_PATHS.FAILED}
              />
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <AuthenticationCallback />
                  </Suspense>
                }
                path={SITE_AUTHENTICATION_PATHS.AUTHENTICATION_CALLBACK}
              />
            </Routes>
          </Grid>
        </Grid>
      </Container>
      <FooterLinks />
    </Stack>
  );
};

export default SiteAuthentication;
